<template>
	<div class="flex justify-center items-center" style="height: 100%">
		<div v-if="formattedSeoValue == 'loading'" class="sloader"></div>
		<vs-chip
			v-else
			:color="getGradColor(formattedSeoValue)"
			style="font-size: 12px"
		>
			&nbsp;&nbsp;{{ formattedSeoValue }}&nbsp;&nbsp;
		</vs-chip>
	</div>
</template>
  
  <script>
import dbFieldConvertorMixin from "@/mixins/dbFieldConvertorMixin.js";
import utilsMixin from "@/mixins/utilsMixin.js";
export default {
	props: {
		value: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			chooseNumber: 0,
		};
	},
	mixins: [utilsMixin, dbFieldConvertorMixin],
	created() {
		if (this.$props.value) {
			this.chooseNumber = this.$props.value;
		} else {
			this.chooseNumber = (this.params && this.params.value) || "-";
		}
	},
	computed: {
		// Format the SEO value (multiplied by 100 and rounded)
		formattedSeoValue() {
			if (!isNaN(this.chooseNumber)) {
				return Number(this.chooseNumber).toFixed(0);
			}
			return this.chooseNumber;
		},
	},
	methods: {
		// Determines the color based on the calculated value
		getGradColor(val) {
			if (isNaN(val)) val = 0;
			if (val == 0) return "#C3C3C3"; // Default color if value is 0
			return this.gradientColor(val); // Get the gradient color
		},
		// Customize gradient color logic
	},
};
</script>
  
  <style scoped>
/* Optional custom styles here */
</style>
  